<template>
  <div>
    <div class="footer">
      <div class="footer-center">
        <div>
          <div>
            <img style="width: 150px;" src="../assets/images/pc_nav_logo.png" alt />
          </div>
          <ul>
            <li>
              <span>{{ $t("message.footer.telephone") }}</span
              >:
              <span>64586539</span>
            </li>
            <li>
              <span>{{ $t("message.footer.whatsapp") }}</span
              >:
              <span>64586539</span>
            </li>
            <li>
              <span>{{ $t("message.footer.emali") }}</span
              >:
              <span>cateraway.cs@funmaxhk.com</span>
            </li>
            <li>
              <span>{{ $t("message.footer.leixing") }}</span
              >:
              <span>295180786</span>
            </li>
            <li>
              <span>{{ $t("message.footer.gongsi") }}</span
              >:
              <span>{{ $t("message.footer.gongsispan") }}</span>
            </li>
            <li>
              <span>
                <template v-if="this.$i18n.locale === 'zh'">
                  <router-link
                    :to="{
                      path: '/terms/',
                      params: { lang: this.$i18n.locale },
                    }"
                  >
                    {{ $t("message.footer.terms") }}
                  </router-link>
                </template>
                <template v-else>
                  <router-link
                    :to="{
                      path: '/en/terms/',
                      params: { lang: this.$i18n.locale },
                    }"
                  >
                    {{ $t("message.footer.terms") }}
                  </router-link>
                </template>
              </span>
              &nbsp;&nbsp;
              <span>
                <template v-if="this.$i18n.locale === 'zh'">
                  <router-link
                    :to="{
                      path: '/privacy/',
                      params: { lang: this.$i18n.locale },
                    }"
                  >
                    {{ $t("message.footer.pri") }}
                  </router-link>
                </template>
                <template v-else>
                  <router-link
                    :to="{
                      path: '/en/privacy/',
                      params: { lang: this.$i18n.locale },
                    }"
                  >
                    {{ $t("message.footer.pri") }}
                  </router-link>
                </template>
              </span>
            </li>
          </ul>
        </div>
        <div>
          <ul>
            <li>
              <a
                style="text-decoration: none"
                href="https://www.facebook.com/caterawayhongkong"
                target="_black"
              >
                <i class="iconfont icon-facebook1"></i>
              </a>
            </li>
            <li>
              <a
                target="_black"
                style="text-decoration: none"
                href="https://www.instagram.com/cateraway/"
              >
                <i class="iconfont icon-instagram"></i>
              </a>
            </li>
            <li>
              <a
                target="_black"
                style="text-decoration: none"
                href="https://api.whatsapp.com/send?phone=85264586539&text=hello%20%E5%88%B0%E6%9C%83%E5%AE%B6,%E6%88%91%E6%83%B3%E8%A8%82%E5%88%B0%E6%9C%83%EF%BC%81%F0%9F%98%8B%F0%9F%98%8B"
              >
                <i class="iconfont icon-whatsapp"></i>
              </a>
            </li>
          </ul>
        </div>
        <div>
          <!-- <div>
            <img src="../assets/images/map.jpg" alt width="100%" />
          </div> -->
          <v-map :map-data="mapData" />
          <div>
            <ul style="margin: 9px 0 0 0">
              <li style="color: #fff">
                <i style="font-size: 0.95em" class="iconfont icon-dizhi"></i>
                <span>{{ $t("message.footer.address") }}</span
                >:
                <span>{{ $t("message.footer.address1") }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GMaps from "./GMap1.vue";
export default {
  data() {
    return {
      mapData: {
        position: { lat: 22.310616890694586, lng: 114.22498365555998 },
        latitude: 22.310616890694586,
        longitude: 114.22498365555998,
        address:
          "Unit D, 12/F, Block 1 Camel Paint Building, 62 Hoi Yuen Rd, Kwun Tong",
      },
    };
  },
  components: {
    "v-map": GMaps,
  },
};
</script>

<style scoped>
.footermo {
  display: none;
}
.footer {
  width: 100%;
  padding: 25px 0;
  background: #2e2d2b;
}
.footer .footer-center {
  width: 80%;
  margin: auto;
  padding: 1% 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.footer .footer-center > div:nth-child(1) {
  flex: 0 0 33%;
}
.footer .footer-center > div:nth-child(2) {
  flex: 0 0 23%;
}
.footer .footer-center > div:nth-child(3) {
  flex: 0 0 45%;
  height: auto;
}
.footer .footer-center > div:nth-child(2) {
  text-align: right;
}
.footer-center > div:nth-child(1) li {
  color: white;
  margin: 15px 0;
}
.footer-center > div:nth-child(1) {
  width: 60%;
}
.footer-center > div:nth-child(2) li {
  display: inline-block;
  margin: 0 10px;
}
.footer-center > div li a {
  text-decoration: none;
  color: #fff;
}
.iconfont {
  color: #fff;
  font-size: 40px;
}
@media (max-width: 1100px) {
  .footer .footer-center > div:nth-child(2) {
    text-align: center;
  }
  .footer-center > div:nth-child(2) li {
    display: block;
    margin-bottom: 20px;
  }
}
@media (max-width: 820px) {
  .footer {
    display: none;
  }
  .footermo {
    display: block;
    background: #2e2d2b;
    width: 100%;
  }
  .footermo > div {
    padding: 30px 0 0 0;
  }
  .footermo-top {
    overflow: hidden;
    padding: 0px 20px;
  }
  .footermo-top > div {
    float: left;
    width: 50%;
  }
  .footermo-top > div li {
    display: inline-block;
  }
  .footermo-bottom li {
    margin: 15px 0;
    color: white;
    padding: 0px 20px;
    font-size: 14px;
  }
  .footermo-bottom li:last-child {
    margin-bottom: 0px;
  }
  .footermo-bottom li a {
    text-decoration: none;
    color: #fff;
  }
}
</style>
